import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { concatMap } from 'rxjs/operators';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyResponse, PaginationCompanyResponse } from 'src/app/models/company.model';
import { PaginationModel, SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PaginationPartnerResponse, PartnerResponse } from 'src/app/models/user.model';
import { AssociateCompanyService } from 'src/app/services/associate.service';
import { CompanyService } from 'src/app/services/company.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-partners-associated',
  templateUrl: './partners-associated.component.html',
  styleUrls: ['./partners-associated.component.scss']
})
export class PartnersAssociatedComponent implements OnInit {
  paginationCompanies = new SimplePaginationModel(0, 5, 0, 0, 0);
  companies: CompanyResponse[] = [];
  partners: PartnerResponse[] = [];
  queueDelete = null;
  deleting: { [key: number]: any } = {};
  showModalCreate = false;
  failedStart = false;
  paginationPartners = new SimplePaginationModel(0, 5, 0, 0, 0);
  filterCompanies = "";
  filterPartners = "";
  partnerId: string | null = null;
  companyId: string | null = null;
  associations: CompanyResponse[] = [];
  currentAssociations: { [key: number]: boolean } = {};
  buttonAssociate: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");

  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;
  @HostListener('window:resize', ['$event'])


  onResize(event: Event) {
    this.drawLink();
  }

  constructor(
    private toastService: ToastrService,
    private associateService: AssociateCompanyService,
    private userService: UserService,
    private companyService: CompanyService
  ) {

  }

  ngOnInit(): void {
    this.getStartData();
  }

  getCompaniesAssociated(partner: PartnerResponse) {
    partner.loading = partner.companies.length == 0;
    this.companyService.getCompaniesAssociatedToPartner(partner.id).subscribe({
      next: (response: ResponseObject) => {
        partner.companies = response.data as CompanyResponse[];
        this.associations = partner.companies;
        this.currentAssociations = {};
        this.associations.forEach(item => {
          this.currentAssociations[item.id] = true;
        });
        this.companies = response.data as CompanyResponse[];
        partner.loading = false;
        this.drawLink();
      },
      error: (error: HttpErrorResponse) => {
        partner.loading = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  getCompany(company: any) {
    this.companyService.getPartnerCompany(company.id).subscribe({
      next: (response: ResponseObject) => {
        if (response.data) {
          this.getPartnerByCompany(response.data.associateUser.email);
        }
      },
      error: (error: HttpErrorResponse) => {
        // partner.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  getPartnerByCompany(partnerEmail: string) {
    this.userService.getPartners(
      partnerEmail,
      this.paginationPartners.page,
      this.paginationPartners.size
    ).subscribe({
      next: (response: ResponseObject) => {
        var tempPartner = response.data as PaginationPartnerResponse;
        this.partners = tempPartner.partners;
        this.partners.forEach((p) => {
          p.companies = [];
        })
        this.paginationPartners.total = tempPartner.total;
        this.paginationPartners.start = this.paginationPartners.page * this.paginationPartners.size + 1;
        this.paginationPartners.end = this.paginationPartners.start + this.partners.length - 1;

        const partnerFind = this.partners.find(item => item.email.includes(partnerEmail));
        if (partnerFind) {
          this.partnerId = partnerFind.id.toString();
          this.filterPartners = partnerFind.email;
          this.getPartners();
          this.getCompaniesAssociated(partnerFind);
        } else {
          this.filterPartners = "";
          this.getPartners();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  selectRow(table: string, row: any) {
    if (table === 'table-partners') {
      if (this.partnerId === row.id) {
        this.resetTables();
        return;
      }
      this.partnerId = row.id;
      this.getCompaniesAssociated(row);
    } else if (table === 'table-associated') {
      if (this.companyId === row.id) {
        this.resetTables();
        return;
      }
      this.companyId = row.id;
      this.getCompany(row);
    }
  }

  resetTables() {
    this.companyId = null;
    this.partnerId = null;
    this.filterCompanies = "";
    this.filterPartners = "";
    this.getPartners();
    this.getCompaniesIsAssociated();
  }

  drawLink() {
    if (this.partnerId) {
      setTimeout(() => {
        const svg = this.svgContainer.nativeElement as SVGElement;
        svg.innerHTML = ''; // Clear previous lines

        const table1Row = document.querySelector(`#table-partners tr.selected`);
        if (table1Row) {
          const rect1 = table1Row.getBoundingClientRect();

          const parentRect = (svg.parentElement as HTMLElement).getBoundingClientRect();

          const x1 = rect1.right - parentRect.left - 12;
          const y1 = rect1.top + rect1.height / 2 - parentRect.top;

          for (const item of this.associations) {
            const relatedRow = document.querySelector(`#table-associated tr[data-id="${item.id}"]`) as HTMLElement;
            if (!relatedRow) continue;

            const rect = relatedRow.getBoundingClientRect();
            const x2 = rect.left - parentRect.left - 12;
            const y2 = rect.top + rect.height / 2 - parentRect.top;

            const xMiddle = x1 + (x2 - x1) / 2;

            this.drawLine(svg, x1, xMiddle, y1, y1);
            this.drawLine(svg, xMiddle, x2, y2, y2);
            this.drawLine(svg, xMiddle, xMiddle, y1, y2);
          }
        }
      }, 50);
    } else {
      const svg = this.svgContainer.nativeElement as SVGElement;
      svg.innerHTML = ''; // Clear previous lines
    }
  }

  drawLine(svg, x1, x2, y1, y2) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', x1.toString());
    line.setAttribute('y1', y1.toString());
    line.setAttribute('x2', x2.toString());
    line.setAttribute('y2', y2.toString());
    line.setAttribute('stroke', '#001f54');
    line.setAttribute('stroke-width', '2');
    svg.appendChild(line);
  }

  closeModalCreate(created) {
    if (created) {
      this.getStartData();
    }
    this.showModalCreate = false;
  }

  confirmDelete(associate) {
    if (this.deleting[associate.id]) {
      return;
    }
    var temp = associate;
    this.queueDelete = null;
    this.deleting[associate.id] = true;
    setTimeout(() => {
      this.deleting[associate.id] = false;
    }, 1000);
  }

  refresh(pagination) {
    pagination.startElement = pagination.pageIndex * pagination.pageSize;
    var temporalLast = pagination.startElement + pagination.pageSize;
    pagination.lastElement = (temporalLast < pagination.total.length) ? temporalLast : pagination.total.length;
    pagination.filter = pagination.total.slice(pagination.startElement, pagination.lastElement);
  }

  timeoutPartner = null;
  writePartner() {
    clearTimeout(this.timeoutPartner);
    this.timeoutPartner = setTimeout(() => {
      this.paginationPartners = new SimplePaginationModel(0, 5, 0, 0, 0);
      this.getPartners();
    }, 200);
  }

  timeoutCompany = null;
  writeCompany() {
    clearTimeout(this.timeoutCompany);
    this.timeoutCompany = setTimeout(() => {
      this.paginationCompanies = new SimplePaginationModel(0, 5, 0, 0, 0);
      this.getCompaniesIsAssociated();
    }, 200);
  }

  getCompaniesIsAssociated() {
    this.associations = [];
    this.currentAssociations = {};

    this.drawLink();
    this.companyService.getPaginationCompaniesIsAssociated(
      this.filterCompanies,
      this.paginationCompanies.page,
      this.paginationCompanies.size
    ).subscribe({
      next: (response: ResponseObject) => {
        var temp = response.data as PaginationCompanyResponse;
        this.paginationCompanies.total = temp.total;
        this.companies = temp.companies;

        this.paginationCompanies.start = this.paginationCompanies.page * this.paginationCompanies.size + 1;
        this.paginationCompanies.end = this.paginationCompanies.start + this.companies.length - 1;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getPartners() {
    this.userService.getPartners(
      this.filterPartners,
      this.paginationPartners.page,
      this.paginationPartners.size
    ).subscribe({
      next: (response: ResponseObject) => {
        var tempPartner = response.data as PaginationPartnerResponse;
        this.partners = tempPartner.partners;
        this.partners.forEach((p) => {
          p.companies = [];
        })
        this.paginationPartners.total = tempPartner.total;
        this.paginationPartners.start = this.paginationPartners.page * this.paginationPartners.size + 1;
        this.paginationPartners.end = this.paginationPartners.start + this.partners.length - 1;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }


  getStartData() {
    this.getCompaniesIsAssociated();
    this.getPartners();
  }

}
